// @flow
export const HEFTY_MENU = [{
  url: '/jobs',
  label: 'Jobs',
}, {
  url: '/getting-started',
  label: 'Getting Started',
}, {
  url: '/assets',
  label: 'Farms & Fields',
}, {
  url: '/map',
  label: 'Map',
}, {
  url: '/my-account',
  label: 'My Account',
}, {
  url: '/order-supplies',
  label: 'Order Supplies',
}, {
  url: '/order-tests',
  label: 'Order Tests',
}]

export const CONTACT_US = '/contact-us'
